import { isBefore, startOfTomorrow } from 'date-fns';
import { DealMappedStatus } from '../dealUtil';

const atRiskFilter = passedDeals => {
  const dateSortedDeals = passedDeals
    .slice()
    .sort(({ TransactionDate: a }, { TransactionDate: b }) => {
      const a1 = new Date(a).getTime();
      const b1 = new Date(b).getTime();
      if (a1 > b1) return 1;
      if (a1 < b1) return -1;
      return 0;
    });

  const filteredDealsByStatus = dateSortedDeals.filter(
    ({ StatusId }) => StatusId > 1,
  );

  const filteredDealsByCompletion = filteredDealsByStatus.filter(
    ({ ARAmount, APAmount }) => {
      if (parseFloat(APAmount) > parseFloat(ARAmount)) {
        return true;
      }
      return false;
    },
  );
  return filteredDealsByCompletion;
};

const totalDealsFilter = passedDeals => {
  const tomorrow = startOfTomorrow();
  return passedDeals.filter(({ ContractDate }) =>
    isBefore(ContractDate, tomorrow),
  );
};

const unmappedFilter = passedDeals =>
  passedDeals.filter(
    ({
      APAmount,
      APAmountMapped,
      APAmountPaid,
      ARAmount,
      ARAmountMapped,
      ARAmountPaid,
    }) => {
      const apStatus = DealMappedStatus({
        amount: APAmount,
        mapped: APAmountMapped,
        paid: APAmountPaid,
      });

      const arStatus = DealMappedStatus({
        amount: ARAmount,
        mapped: ARAmountMapped,
        paid: ARAmountPaid,
      });

      if (apStatus === 'Unmapped' && arStatus === 'Unmapped') {
        return true;
      }
      return false;
    },
  );

const completeFilter = passedDeals =>
  passedDeals.filter(
    ({
      APAmount,
      APAmountMapped,
      APAmountPaid,
      ARAmount,
      ARAmountMapped,
      ARAmountPaid,
    }) => {
      const apStatus = DealMappedStatus({
        amount: APAmount,
        mapped: APAmountMapped,
        paid: APAmountPaid,
      });

      const arStatus = DealMappedStatus({
        amount: ARAmount,
        mapped: ARAmountMapped,
        paid: ARAmountPaid,
      });

      if (apStatus === 'Complete' && arStatus === 'Complete') {
        return true;
      }
      return false;
    },
  );

export { atRiskFilter, totalDealsFilter, unmappedFilter, completeFilter };
